const broadcastStatuses = {
    ACTIVE: 'active',
    INACTIVE: 'inactive'
};
Object.freeze(broadcastStatuses);
export default broadcastStatuses;